import styled, { css } from 'styled-components';
import Row from '~components/dumbs/Row';
import Column from '~components/dumbs/Column';
import Text from '~components/dumbs/Text';
import { ImageProps } from './types';

export const Container = styled(Column)`
  height: 100%;
  overflow: hidden;
`;

export const Content = styled(Row)`
  flex: 1;
  justify-content: center;
  align-items: center;
  text-align: center;
`;

export const FooterContainer = styled(Column)`
  padding-bottom: ${({ theme }) => theme.spacing.km4};
  padding-left: ${({ theme }) => theme.spacing.km6};
  padding-right: ${({ theme }) => theme.spacing.km6};
`;

export const IsTextPhotoGood = styled(Text)`
  font-weight: ${({ theme }) => theme.font.weight.medium};
  padding: ${({ theme }) => theme.spacing.km4};
`;

export const Image = styled.image.attrs({ 'data-testid': 'image' })<ImageProps>`
  background: url(${({ $src }) => $src});
  background-repeat: no-repeat;
  background-position: center;
  background-size: contain;
  flex: 2;

  ${({ $rotate }) =>
    $rotate &&
    css`
      transform: rotate(90deg);
    `}
`;
